$(document).on('ready turbolinks:load', function() {
  $('body').on('change', '#schedule-date-selector, #schedule-view-selector', function() {
    form = document.querySelector('#schedule-date-form');

    if ($(form).data('remote') == 'true') {
      Rails.fire(form, 'submit');
    } else {
      $(form).submit();
    }
  });
});
